const ApprovalsActionTypes = {
  ADD_APPROVALS_TO_LIST: 'ADD_APPROVALS_TO_LIST',
  DELETE_APPROVAL_FROM_LIST: 'DELETE_APPROVAL_FROM_LIST',
  FILTER_APPROVALS: 'FILTER_APPROVALS',
  DELETE_MULTIPLE_APPROVALS: 'DELETE_MULTIPLE_APPROVALS',
  RESET_FILTERS: 'RESET_FILTERS',
};

export default ApprovalsActionTypes;
